import React from "react";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import CheckoutAccordion from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion";
import checkoutAccordianStyles from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion.module.scss";
import CheckoutFormGroupHeader from "repoV2/features/CheckoutPages/modules/CheckoutFormGroupHeader/CheckoutFormGroupHeader";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { useOrderBumpsFormGroup } from "./OrderBumpsFormGroup.utils";
import OrderBumpsCard from "./modules/OrderBumpsCard/OrderBumpsCard";
import styles from "./OrderBumpsFormGroup.module.scss";

const OrderBumpsFormGroup = () => {
    const {
        orderBumpsListing = [],
        enableRedirectionOnOrderBumps,
        orderBumpsFormGroupsHeading,
        handleOrderBumpsSelection,
        selectedOrderBumps,
    } = useOrderBumpsFormGroup();

    if (checkIsArrayEmpty(orderBumpsListing)) {
        return null;
    }

    return (
        <CheckoutAccordion
            defaultExpanded
            showExpandIcon={false}
            title={
                <CheckoutFormGroupHeader
                    title={orderBumpsFormGroupsHeading}
                    iconJSX={
                        <CardGiftcardOutlinedIcon
                            className={styles.headerIconStyle}
                        />
                    }
                />
            }
            className={checkoutAccordianStyles.Wrapper}
            disabled
            classes={{
                root: checkoutAccordianStyles.formGroupRoot,
                disabled: checkoutAccordianStyles.formGroupDisabled,
            }}
            headerClasses={{
                root: checkoutAccordianStyles.headerRoot,
                content: checkoutAccordianStyles.headerContent,
                disabled: checkoutAccordianStyles.formGroupDisabled,
                expanded: checkoutAccordianStyles.formGroupExpanded,
            }}
        >
            <div className={styles.orderBumpsContainer}>
                {orderBumpsListing.map(orderBumpsListingData => (
                    <OrderBumpsCard
                        key={orderBumpsListingData.additional_listing_uid}
                        orderBumpsListingData={orderBumpsListingData}
                        handleOrderBumpsSelection={handleOrderBumpsSelection}
                        selectedOrderBumps={selectedOrderBumps}
                        enableRedirectionOnOrderBumps={
                            enableRedirectionOnOrderBumps
                        }
                    />
                ))}
            </div>
        </CheckoutAccordion>
    );
};

export default OrderBumpsFormGroup;
